import * as React from "react"
import * as DrupalModel from '../../../custom_models/drupal'
import { getCookie } from "../../../custom_utils/cookies"
import { PREF_BRANCH_COOKIE, confirmLocation } from "./LocalizationState"
import { convertEmToPx } from "../../../custom_utils/helpers"

interface LocalizationProps {
  readonly selectedLocationId: string
  readonly branchLocations: DrupalModel.Location[]
  readonly selectLocation: (selectedId: string) => void
}

export const toggleLocationDropdown = (dropdownOpen:'true'|'false') => {
  const trigger:HTMLElement = document.querySelector('#a11y-location-toggler');
  const target:HTMLElement = document.querySelector('#a11y-location-dropdown');
  const closeTrigger:HTMLElement = document.querySelector('#a11y-location-close');
  if(trigger == null || target == null || closeTrigger == null) { return; }

  if(dropdownOpen == 'true') {
    trigger.setAttribute('aria-expanded', 'false');
    closeTrigger.setAttribute('aria-expanded', 'false');
    target.setAttribute('aria-hidden', 'true');  
  } else {
    trigger.setAttribute('aria-expanded', 'true');
    closeTrigger.setAttribute('aria-expanded', 'true');
    target.setAttribute('aria-hidden', 'false');
  }
}

export const Localization = {
  LocationDropdown: (props: LocalizationProps) => {
    const { selectedLocationId, branchLocations, selectLocation } = props
    const preferredBranchId = getCookie(PREF_BRANCH_COOKIE)
    const preferredBranch = branchLocations.find((loc) => loc.id == preferredBranchId)

    const isDesktop = window.innerWidth > convertEmToPx(102.4)

    return <div className="lh__dropdown">
    <div className="lh__formwrap">
      
      {isDesktop ?
      <>
        {/* <span className="lh__formlabel">Mijn bieb:</span> */}
        <div className="lh__buttoninput">
          <button
            id="a11y-location-toggler"
            className="lh__button"
            aria-controls="a11y-location-dropdown"
            aria-expanded="false"
            onClick={(e) => toggleLocationDropdown(e.currentTarget.getAttribute('aria-expanded') == 'true' ? "true" : "false")}
          >{preferredBranch ? preferredBranch.title : "Selecteren"}</button>
          <svg className="lh__icon" aria-hidden="true" fill="none" height="10" viewBox="0 0 14 10" width="14" xmlns="http://www.w3.org/2000/svg"><path clipRule="evenodd" d="m.324282.989902c.407119-.373192 1.039688-.345689 1.412878.061428l5.26285 5.74129 5.26289-5.74129c.3731-.407117 1.0057-.43462 1.4128-.061428.4071.373188.4347 1.005758.0615 1.412878l-6.00004 6.54546c-.18941.20663-.45685.32428-.73715.32428-.28031 0-.54775-.11765-.73716-.32428l-5.999999-6.54546c-.373192-.40712-.3456886-1.03969.061431-1.412878z" fill="#090b09" fillRule="evenodd"/></svg>

          <div id="a11y-location-dropdown" className="lh__options lho" aria-hidden="true">
            <div className="lho__inner">
                {preferredBranch && 
                  <div className="lho__option">
                    <input checked={selectedLocationId == "0"} onChange={(e) => selectLocation(e.target.value) } type="radio" name="branch" id="lho_0" value="0" onFocus={(e) => toggleLocationDropdown("false")} onBlur={(e) => document.querySelector('#a11y-location-dropdown:focus-within') != null ? undefined : toggleLocationDropdown("true")} />
                    <label htmlFor="lho_0">Geen voorkeur</label>
                  </div>
                }
              {branchLocations.map((loc) => {
                return (
                  <div className="lho__option" key={loc.id}>
                    <input checked={selectedLocationId == loc.id} onChange={(e) => selectLocation(e.target.value) } type="radio" name="branch" id={"lho_" + loc.id} value={loc.id} onFocus={(e) => toggleLocationDropdown("false")} onBlur={(e) => document.querySelector('#a11y-location-dropdown:focus-within') != null ? undefined : toggleLocationDropdown("true")} />
                    <label htmlFor={"lho_" + loc.id}>{loc.title}</label>
                  </div>
                )
              })}
            </div>
            <div className="lho__submit">
              <button
                id="a11y-location-close"
                className="lho__button button"
                aria-controls="a11y-location-dropdown"
                aria-expanded="false"
                disabled={!selectedLocationId}
                onClick={(e) => confirmLocation(selectedLocationId, branchLocations)}
                onFocus={(e) => toggleLocationDropdown("false")}
                onBlur={(e) => document.querySelector('#a11y-location-dropdown:focus-within') != null ? undefined : toggleLocationDropdown("true")}
              >Selecteer als mijn bieb</button>
            </div>
          </div>
        </div>
      </>
      :
      <>
        <label className="lh__formlabel" htmlFor="lh-location">Mijn bieb:</label>
        <div className="lh__forminput">
          <select className="lh__select" id="lh-location" value={preferredBranchId} onChange={(e) => confirmLocation(e.target.value, branchLocations)}>
            <option value="">{preferredBranchId ? "Geen locatie": "Selecteren"}</option>
            {branchLocations.map((loc) => {
              return <option key={loc.id} value={loc.id}>{loc.title}</option>
            })}
          </select>
          <svg className="lh__icon" aria-hidden="true" fill="none" height="10" viewBox="0 0 14 10" width="14" xmlns="http://www.w3.org/2000/svg"><path clipRule="evenodd" d="m.324282.989902c.407119-.373192 1.039688-.345689 1.412878.061428l5.26285 5.74129 5.26289-5.74129c.3731-.407117 1.0057-.43462 1.4128-.061428.4071.373188.4347 1.005758.0615 1.412878l-6.00004 6.54546c-.18941.20663-.45685.32428-.73715.32428-.28031 0-.54775-.11765-.73716-.32428l-5.999999-6.54546c-.373192-.40712-.3456886-1.03969.061431-1.412878z" fill="#090b09" fillRule="evenodd"/></svg>
        </div>
      </>
      }
    </div>
  </div>
  }
}
